import { render } from "./icon-pulse-share.svg?vue&type=template&id=e500bb8c&scoped=true&component"
const script = {}

import "./icon-pulse-share.svg?vue&type=style&index=0&id=e500bb8c&scoped=true&lang=css&component"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e500bb8c"]])

export default __exports__